var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 63.991,
    height: 88.336,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 49 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_x0020_1",
    fill: "none",
    stroke: "#999",
    strokeWidth: 0.512186,
    d: "M34 68c-2-5-4-6-4-8s-1-5 3-11c3 0 7 2 10 1v-5s1 0 1-1c0 0-1-1 0-2 0-1 2-1 2-1-1-1 0-4 0-4 1 0 2 1 3-1 0-3-4-6-4-9 0-1 0-2 1-2 2 0 0-7 0-8s2-2 1-3c-1-4-2-6-4-7-3-2-6-3-8-4-5-3-8-4-16-2-4 1-3 1-7 3-12 7-9 19-9 28 2 3 2 6 5 7s4 2 6 5c0 3 0 3-3 8l-5 5c-1 1-4 6-6 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRight);
export default __webpack_public_path__ + "static/media/AvatarRight.0c9c4a83eb1caac717215a30533adeb8.svg";
export { ForwardRef as ReactComponent };